import ptBrTranslations from '../locales/pt-br'
import enUsTranslations from '../locales/en-us'
import esTranslations from '../locales/es'

export default {
  'pt-BR': ptBrTranslations,
  'en-US': enUsTranslations,
  'es': esTranslations
}